<template>
  <FormInputWrapper :error="error" :label="label" :required="required">
    <div class="flex flex-col gap-y-1">
      <label v-for="option in answerOptions" :key="option" class="flex min-h-8 cursor-pointer items-start gap-2 py-1 pr-2 text-sm text-black1 md:px-4">
        <input class="sr-only" type="radio" :checked="modelValue === option" :value="option" @input="onUpdateModelValue?.(option)" />
        <span class="mt-0.5 box-border inline-block h-4 w-4 shrink-0 rounded-full border border-solid" :class="[modelValue === option ? 'border-black1 bg-black1' : 'border-gray2 bg-white']" />
        <span class="min-w-0 break-words">{{ option }}</span>
      </label>
    </div>
  </FormInputWrapper>
</template>

<script setup lang="ts">
import { FormInputWrapper } from '@/wabunka-src/common/components';

interface Props {
  label: string;
  modelValue: string;
  answerOptions: string[];
  onUpdateModelValue?: (value: string) => void;
  required?: boolean;
  error?: string;
}

withDefaults(defineProps<Props>(), {
  onUpdateModelValue: undefined,
  required: true,
  error: '',
});
</script>
